// 依 react-easy-crop 的 croppedAreaPixels 將原圖裁切成 JPEG blob。
// 來源為本機 object URL（同源），無 CORS 問題。
export default function getCroppedBlob(imageSrc, pixelCrop) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            try {
                const canvas = document.createElement('canvas');
                canvas.width = Math.max(1, Math.round(pixelCrop.width));
                canvas.height = Math.max(1, Math.round(pixelCrop.height));
                const ctx = canvas.getContext('2d');
                ctx.drawImage(
                    image,
                    pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
                    0, 0, canvas.width, canvas.height,
                );
                canvas.toBlob(
                    (blob) => (blob ? resolve(blob) : reject(new Error('裁切失敗'))),
                    'image/jpeg',
                    0.9,
                );
            } catch (e) {
                reject(e);
            }
        };
        image.onerror = () => reject(new Error('圖片載入失敗'));
        image.src = imageSrc;
    });
}
